<template>
  <div></div>
</template>

<script>
export default {
  name: 'Logout',
  mounted () {
    this.$http.post('/auth/logout').then(() => {
      window.localStorage.setItem('token', '');
      this.$store.commit('user/logoutUser');
      this.$http.defaults.headers.Authorization = 'Bearer none';
      this.$router.push({ name: 'Logowanie' });
    }).catch((error) => {
      console.log(error);
      window.localStorage.setItem('token', '');
      this.$http.defaults.headers.Authorization = 'Bearer none';
      this.$router.push({ name: 'Logowanie' });
    });
  }
}
</script>
